const hu = {
  accept: "Elfogad",
  changeLanguage: "Nyelvválasztás",
  footer: {
    mainPage: {
      mainPageText1: "SZEMÉLYRE SZABOTT MEGOLDÁSOK. PONT ÚGY, AHOGY ÖN SZERETNÉ.",
      askForOffer: "Kérjen ajánlatot most!",
      aboutUs: "Rólunk",
      solutions: "Megoldások",
      socialMedia: "Social-Media",
      aboutInvitech: "A One-ról",
      references: "Referenciák",
      career: "Karrier",
      socialResponsibility: "Társadalmi felelősségvállalás",
      centralizedProcurement: "Központosított beszerzés",
      smartVillage: "Okosfalu",
      forLargeCompanies: "Nagyvállalatoknak",
      forSmallAndMediumCompanies: "Kis és középvállalkozásoknak",
      forInstitutions: "Intézményeknek",
      forWholesalers: "Nagykereskedőknek",
      businessServices: "Vállalati szolgáltatások",
      infrastructureServices: "Infrastruktúra szolgáltatások",
      news: "Hírek",
      press: "Sajtó",
      blog: "Blog",
      loginToCustomerPortal: "Belépés az ügyfélportálra",
      loginToTechnicalPortal: "Belépés a technikai portálra"
    },
    dataProtection: "Adatvédelem",
    dataProcessingCode: "Adatfeldolgozói kódex",
    termsAndConditions: "ÁSZF",
    gtc: "ÁSZF",
    certificates: "Tanúsítványaink",
    impress: "Impresszum",
    providerInformation: "Szolgáltató adatai",
    filteringSoftware: "Szűrőszoftver",
    coServiceOffers: "Társszolgáltatói ajánlatok",
    premiumServices: "Emelt díjas szolgáltatások",
    socialResponsibility: "Társadalmi felelősségvállalás (InnoMax)",
    iivrApplication: "IIVR Pályázat"
  },
  urls: {
    aboutInvitech: "https://www.invitech.hu/invitechrol",
    references: "https://www.invitech.hu/ugyfeleink",
    socialResponsibility: "https://www.invitech.hu/innomax-fooldal", centralizedProcurement: "https://www.invitech.hu/kozpontositott-beszerzes",
    forLargeCompanies: "https://www.invitech.hu/vallalati-szolgaltatasok-gyujto",
    forSmallAndMediumCompanies: "https://www.invitech.hu/kis-es-kozepvallalkozasok-gyujto",
    forInstitutions: "https://www.invitech.hu/kozpontositott-beszerzes",
    businessServices: "https://www.invitech.hu/vallalati-szolgaltatasok-gyujto",
    infrastructureServices: "https://www.invitech.hu/infrastruktura",
    news: "https://www.invitech.hu/hirek",
    dataProcessingCode: "https://www.invitech.hu/storage/pbB0key1ENoZhpMpb0LVtlWc9sgyyEU6eIrQ98by.pdf",
    gtc: "https://www.invitech.hu/altalanos-szerzodesi-feltetelek-invitech",
    certificates: "https://www.invitech.hu/tanusitvanyaink",
    impress: "https://www.invitech.hu/impresszum",
    providerInformation: "https://www.invitech.hu/szolgaltato-adatai"
  },
  fields: {
    companyName: "Előfizető cég, intézmény neve",
    taxNumber: "Adószám",
    giroNumber: "Szerződéses folyószámlaszám",
    contact: "Kapcsolattartó",
    position: "Beosztás",
    mobile: "Mobilszám",
    email: "E-mail cím"
  },
  cannotBeEmpty: "Nem lehet üres",
  formatError: "Formátum hiba",
  mobileFormatError: "Formátum hiba (pl. +36...)",
  taxFormatError: "Formátum hiba (pl. 12345678-1-12)",
  registration: "Regisztráció",
  regDescr: "Adataik védelme érdekében cégüket, intézményüket csak egy, a szerződésükben feltüntetett kapcsolattartó tudja regisztrálni. Kollégáit egy fő, már regisztrált kapcsolattartó invitálhatja meg, érdemes erre egy operatív személyt kijelölniük. Munkatársai számára egyedileg határozhat meg jogosultságokat beosztásuk szerint.",
  mandatory: "kötelezően kitöltendő",
  success: "Sikeres",
  errorDuringRegistration: "Hiba a regisztrációs folyamat közben. Kérem, próbálja újra!"
};

export default hu;
